var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',_vm._l((_vm.weekdays),function(weekday){return _c('th',{key:weekday,domProps:{"textContent":_vm._s(_vm.$t(weekday))}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }